import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import EditClassDetails from "./EditClassDetails";
import SaveClassDetails from "./SaveClassDetails";
import EditClassTeacherDetails from "./EditClassTeacherDetails";
import BackButton from "./BackButton";
import DeleteClassButton from "./DeleteClassButton";
import { getClassOwnerChangeReasons, whoami } from "../services/APIClient"; // Import the function to fetch reasons
import "./ClassOverview.css";

function ClassSettingsOverview(props) {
  let group = props.group;
  let classDetails = props.classDetails.classDetails;
  let name = props.name;
  let teachers = props.teachers.teachers;
  let teacherid = props.teacherid;
  let classOwnerId = group.classOwnerId;
  let teacherRoles = props.teacherRoles;
  let gradeLevel = props.gradeLevel;

  let [newClassName, setNewClassName] = useState(name || "");
  let [classTeacherName, setClassTeacherName] = useState("");
  const [newClassTeacherId, setNewClassTeacherId] = useState("");
  const [classOwnerName, setClassOwnerName] = useState("");
  const [classOwnerChangeReason, setClassOwnerChangeReason] = useState(""); // State for selected reason
  const [classOwnerChangeReasons, setClassOwnerChangeReasons] = useState([]); // State for reasons array
  const [schoolid, setSchoolid] = useState([]);
  const [showChangeReasonDropdown, setShowChangeReasonDropdown] =
    useState(false); // To toggle dropdown
  const [changeReasons, setChangeReasons] = useState([]); // To store fetched reasons
  const [selectedReason, setSelectedReason] = useState({ id: "", reason: "" }); // Initialize as an object

  // Fetch class owner change reasons
  useEffect(() => {
    const fetchClassOwnerChangeReasons = async () => {
      try {
        const reasons = await getClassOwnerChangeReasons();
        console.log(reasons);
        setClassOwnerChangeReasons(reasons); // Store the reasons array
      } catch (error) {
        console.error("Error fetching class owner change reasons:", error);
      }
    };

    fetchClassOwnerChangeReasons();
  }, []);

  useEffect(() => {
    whoami().then((response) => {
      setSchoolid(response.data.stakeholder.schoolid);
    });
  }, [schoolid]);

  // Update class name
  const updateClassName = (name) => {
    console.log("Updating Class Name:", name); // Log the name received from the child component
    // Avoid setting to empty string
    if (name.trim() !== "") {
      setNewClassName(name);
    }
  };

  useEffect(() => {
    if (teachers && teacherid) {
      const teacher = teachers.find((teacher) => teacher.id === teacherid);
      if (teacher) {
        setClassTeacherName(teacher.name);
      }
    }
  }, [teacherid, teachers]);

  useEffect(() => {
    const classOwner = teachers.find((teacher) => teacher.id === classOwnerId);
    if (classOwner) {
      setClassOwnerName(classOwner.name);
    }
  }, [classOwnerId]);

  return (
    <div className="class-overview-container">
      <Container className="container-shape">
        <Row className="page-description-bar">
          <Col>
            <h2 className="page-description-header">{name}</h2>
            <p>Edit the details of your class.</p>
          </Col>
        </Row>
        <hr />
        <Row className="button-container">
          <Col className="col-7 vertical-border">
            <EditClassDetails
              group={group}
              classDetails={classDetails}
              teachers={teachers}
              name={name}
              sendUpdateClassName={updateClassName}
            />
            <EditClassTeacherDetails
              currentTeacherName={classTeacherName}
              teachers={teachers}
              setNewClassTeacherId={setNewClassTeacherId}
              classOwnerName={classOwnerName}
              setClassOwnerChangeReason={setClassOwnerChangeReason} // Pass the setter for reason
              classOwnerChangeReasons={classOwnerChangeReasons} // Pass the reasons array
              setShowChangeReasonDropdown={setShowChangeReasonDropdown}
              setChangeReasons={setChangeReasons}
              setSelectedReason={setSelectedReason}
              showChangeReasonDropdown={showChangeReasonDropdown}
              changeReasons={changeReasons}
            />
            <Row className="button-placer">
              <Col className="col-6">
                <BackButton />
              </Col>
              <Col className="col-6">
                <SaveClassDetails
                  newClassName={newClassName || name}
                  classDetails={classDetails}
                  teachers={teachers}
                  gradeLevel={gradeLevel}
                  newClassTeacherId={newClassTeacherId}
                  classOwnerChangeReason={classOwnerChangeReason} // Pass the selected reason to save
                  teacherid={teacherid}
                  selectedReason={selectedReason}
                  classOwnerId={classOwnerId}
                  changeReasons={changeReasons}
                  schoolid={schoolid}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ClassSettingsOverview;
